/* eslint-disable */
import vue from "@/main.js";
//判断客户端是android还是ios
export function getDeviceType() {
  //var result = "";
  let u = navigator.userAgent;
  let myOS = "android";
  if (u.indexOf('iPhone') > -1 || u.indexOf('iPad') > -1) { // 苹果手机
    myOS = "IOS";
  }
  return myOS;
}
export function is_wei() {
  let ua = navigator.userAgent.toLowerCase();
  let is_weixn = false;
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    is_weixn = true;
  }
  return is_weixn;
}
export const closePage = toastText => {
  vue.$toast.loading({
    duration: 0, // 持续展示 toast
    forbidClick: true,
    message: toastText
  });
  const timer = setInterval(() => {
    clearInterval(timer);
    vue.$toast.clear();
    if (getDeviceType() == "android") {
      window.android.getInfo(103);
    } else {
      window.webkit.messageHandlers.closePage.postMessage("1");
    }
  }, 1000);

}
//判断手机是否是iphone以上手机
export const isIphonex = () => {
  if (typeof window !== 'undefined' && window) {
    return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
  }
  return false;
};